(ns frontend.ui.page.lp-report-editor.step-7-published.sub
  (:require
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]))

(def report-tab-path (conj editor-sub/editor-path :published-report-tab))

